import React from 'react'
import { Box, IconButton } from '@mui/material'
import MailIcon from '@mui/icons-material/Mail'
import EditIcon from '@mui/icons-material/Edit'

import { useUserCalls, useUserDialogs } from '../../hooks'
import { useLoaderBasic } from '../../../loader/hooks'

export const TableActions = ({ row }) => {
  const { resendValidation, updateClientInfo, getUsers } = useUserCalls()
  const { warnValidationMailSuccess, editClientDialog } = useUserDialogs()
  const {
    state: { config },
    loadData,
  } = useLoaderBasic({ identifier: 'users', call: getUsers })

  const rowData = row?.original

  if (!rowData) {
    return null
  }

  const handleEdit = () => {
    editClientDialog(rowData, (id, payload) =>
      updateClientInfo(id, payload).then(() => loadData(config))
    )
  }

  const handleForward = () => {
    resendValidation(rowData['email']).then(warnValidationMailSuccess)
  }

  const showForwardButton = rowData['oauth2_id'] && !rowData['confirmed']

  const actionButtonStyles = {
    border: '1px solid #333',
    borderRadius: '50%',
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem',
    },
  }

  const columnStyles = {
    flex: '1',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Box sx={columnStyles}>
        <IconButton size="small" onClick={handleEdit} sx={actionButtonStyles}>
          <EditIcon />
        </IconButton>
      </Box>
      <Box sx={columnStyles}>
        {showForwardButton && (
          <IconButton size="small" onClick={handleForward} sx={actionButtonStyles}>
            <MailIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  )
}
